import { ChevronDown } from 'lucide-react'
import type { Me } from '@/lib/api'
import { useCircleColor } from '@/lib/circleColor'
import type { Family } from '@/lib/families'
import { useCurrentSpace } from '@/lib/spaces'
import { cn } from '@/lib/utils'
import type { Place } from './places'
import { ProfileMenu } from './ProfileMenu'
import { CircleDot } from './YouFace'

// On a phone, a section's own page names where you are under the bar: Everyone, Me or the circle, with its room when
// you've picked one other than the circle's own. The bar itself never carries it (Dallas, 2026-10-14); this line
// scrolls away with the page. Tapping it opens your profile's sheet, where you switch (mobile review, Dallas
// 2026-10-18).
export function WhereYouAre({
  me,
  family,
  places,
  className,
}: {
  me: Me
  family: Family | null
  places: Place[]
  className?: string
}) {
  const color = useCircleColor()
  const space = useCurrentSpace(family ?? undefined)
  const room = family && space && space.kind !== 'everyone' ? space.name : null
  const name = family ? (room ? `${family.name} · ${room}` : family.name) : 'Everyone'
  return (
    <ProfileMenu me={me} places={places}>
      <button
        type="button"
        aria-label={`You're in ${name}. Switch circles`}
        className={cn(
          'flex min-h-11 max-w-full min-w-0 items-center gap-2 self-start rounded-full text-sm font-medium text-muted-foreground outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50',
          className,
        )}
      >
        {family && color && <CircleDot color={color} className="size-3" />}
        <span className="truncate">{name}</span>
        <ChevronDown className="size-4 shrink-0" aria-hidden />
      </button>
    </ProfileMenu>
  )
}
